import React, { useState, useEffect } from 'react'
import pathname from '../../constants/pathname'
import ProjectDataTable from '../dataTable/ProjectDataTable'
import { useHistory } from 'react-router-dom'
import { getExpertWaitScrutinizeApproval } from '../../redux/actions/dashboard'
import DashboradToggle from './DashboradToggle'
import TableLoadingTemplate from '../loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'

export default function ExpertWaitScrutinizeApproval({ config, onSettingChange = () => {} }) {
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  let history = useHistory()

  useEffect(() => {
    if (config) {
      setSchema(settingSchema)
    } else {
      handelGetSchemaDashboard(5, 1)
    }
  }, [])

  const handelGetSchemaDashboard = async (
    pagesize,
    pagenumber,
    projectCodeSearch,
    projectNameSearch
  ) => {
    setIsLoading(true)
    // startLoading()
    try {
      const response = await getExpertWaitScrutinizeApproval(
        pagesize,
        pagenumber,
        projectCodeSearch,
        projectNameSearch
      )
      // console.log('dddd 8520 => ', response)
      setSchema(response)
    } catch (e) {
      setError({})
    }
    // doneLoading()
    setIsLoading(false)
  }

  const onSingleSubmit = (obj) => {
    sessionStorage.setItem('projectId', obj.id)
    sessionStorage.setItem('param', '')
    // console.log('id', obj.ig)
    history.push(`${pathname.proposal.overview.overviewCoworker}`)
  }
  // filter

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {schema && (
        <>
          {config && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={config.key}
              checked={config.show}
              style={{ marginTop: 20, marginBottom: -15 }}
            />
          )}

          <ProjectDataTable
            schema={schema}
            subName={{ enable: true }}
            // multi={{ enable: true, buttonText: 'ไปยังการอนุมัติผู้ทรงคุณวิฒิ' }}
            single={{
              enable: true,
              // buttonText: schema?.buttonText,
              buttonText: 'แสดง',
              // icon: schema?.singleIcon,
              icon: 'eye',
            }}
            onSingleSubmit={onSingleSubmit}
            // onMultiSubmit={onMultiSubmit}
            pagination={true}
            onReload={handelGetSchemaDashboard}
            loading={isLoading}
            searchEnable={true}
            resizeProjectTypeField={true}
            setting={config && true}
          />
        </>
      )}
    </>
  )
}

const settingSchema = {
  header: 'โครงการที่รออนุมัติผู้ทรงคุณวุฒิสำหรับกลั่นกรองทางวิชาการ',
  projectCodeText: 'รหัสโครงการ',
  projectNameText: 'ชื่อโครงการ',
  projectTypeText: 'ประเภทโครงการ',
  projectBudgetText: 'งบประมาณรวม',
  buttonText: 'กลั่นกรอง',
  mutiButtonText: 'ไปยังการกลั่นกรอง',
  singleIcon: 'check-circle',
  totalSize: 1,
  values: [
    {
      id: '',
      projectCode: 'XX-XXXXX',
      projectName: { name: 'โครงการ XXXXX', statusName: null },
      projectBudget: '9,999,999.99',
      projectType: { value: 'โครงการ', label: '1' },
    },
  ],
}
